<template>
  <div class="vet-disclaimer">
    <fn-icon
      class="icon"
      icon="circle-i-light"
    />
    <div>
      <span>{{ text }}</span>
      <span
        class="vd-clickable"
        @click="handleScroll"
      >
        {{ $t('buttons.furtherInformation') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  emits: ['setActiveTab'],
  methods: {
    handleScroll() {
      document.querySelector('#productDetails')?.scrollIntoView({
        behavior: 'smooth',
      });
      this.$emit('setActiveTab', 'detailedProductDetails');
    },
  },
};
</script>

<style lang="scss" scoped>
.vet-disclaimer {
  position: relative;
  padding: 32px $pad $pad;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    padding-left: $pad;
  }

  span:last-child {
    font-weight: 700;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
